import { Firebase } from './firebase.class';
import type { FirebaseCallbackOptions } from './interfaces';

export const getFirebase = (callbacks: FirebaseCallbackOptions): Firebase => {
  const firebaseInstance = new Firebase(callbacks);

  window.Firebase = firebaseInstance;

  return firebaseInstance;
};
